import React from 'react'
import { Route, Routes } from 'react-router-dom'

import Details from './screens/Details'
import Relations from './screens/Relations'
import AuditLog from './screens/AuditLog'

const ProductEditRoutes = () => (
  <Routes>
    <Route index element={<Details />} />
    <Route path="/relations" element={<Relations />} />
    <Route path="/auditLog" element={<AuditLog />} />
  </Routes>
)

export default ProductEditRoutes
